import { type Drill, type XY } from '../types';

export type FieldPreset = 'full' | 'half' | 'threequarters';

export const FIELD_WIDTH = 1000;
export const GOAL_CENTER_Y = 0;

export function getFieldHeight(preset: FieldPreset): number {
  switch (preset) {
    case 'half':
      return 600;
    case 'threequarters':
      return 800;
    case 'full':
    default:
      return 1000;
  }
}

export function getFieldDimensions(preset: FieldPreset): { width: number; height: number } {
  return {
    width: FIELD_WIDTH,
    height: getFieldHeight(preset),
  };
}

export function getDrillOrientation(drill?: Drill): 'left' | 'right' {
  void drill;
  return 'right';
}

export function applyOrientation(point: XY, orientation: 'left' | 'right'): XY {
  if (orientation === 'left') {
    return { x: FIELD_WIDTH - point.x, y: point.y };
  }
  return point;
}

export function getGoalCenter(preset: FieldPreset = 'threequarters'): XY {
  void preset;
  return { x: FIELD_WIDTH / 2, y: GOAL_CENTER_Y };
}
